import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row d-flex align-items-center mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "mb-4" }, "Check Replacement Request "),
    /*#__PURE__*/_createElementVNode("p", null, "If you have misplaced your vacation check or it is stale-dated, you can request a replacement by completing the information below.")
  ])
], -1)
const _hoisted_3 = {
  key: 0,
  class: "alert alert-success"
}
const _hoisted_4 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_5 = { class: "form-group row mb-4" }
const _hoisted_6 = { class: "col-md-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "participant_id",
  class: "col-form-label text-md-right"
}, "Participant ID", -1)
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "first_name",
  class: "col-form-label text-md-right"
}, " First Name ", -1)
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "last_name",
  class: "col-form-label text-md-right"
}, " Last Name ", -1)
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "date_of_birth",
  class: "col-form-label text-md-right"
}, " Date of Birth ", -1)
const _hoisted_14 = { class: "form-group row mb-4" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "check_type",
  class: "col-form-label text-md-right"
}, " Check Type ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "vacation" }, "Vacation", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: "medicare" }, "Medicare Reimbursement", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: "pension" }, "Pension", -1)
const _hoisted_20 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  for: "type",
  class: "col-form-label text-md-right"
}, " Type ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("option", { value: "directdeposit" }, "Direct Deposit", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", { value: "check" }, "Check", -1)
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = {
  key: 2,
  class: "form-group row mb-4 check-fields"
}
const _hoisted_27 = { class: "col-md-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  for: "check_list",
  class: "col-form-label text-md-right"
}, " Check List ", -1)
const _hoisted_29 = { class: "col-md-4" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  for: "check_date",
  class: "col-form-label text-md-right"
}, " Check Date ", -1)
const _hoisted_31 = { class: "col-md-4" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", {
  for: "check_number",
  class: "col-form-label text-md-right"
}, " Check # ", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h3", null, " Address for Check Destination currently on File ", -1)
const _hoisted_34 = {
  key: 3,
  class: "form-group row mb-4"
}
const _hoisted_35 = { class: "col-md-4" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", {
  for: "address",
  class: "col-form-label text-md-right"
}, "Address", -1)
const _hoisted_37 = { class: "col-md-4" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  for: "address2",
  class: "col-form-label text-md-right"
}, "Address 2", -1)
const _hoisted_39 = { class: "col-md-4" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { for: "country" }, "Country", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Country", -1)
const _hoisted_42 = ["value"]
const _hoisted_43 = { class: "col-md-4" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "col-form-label text-md-right"
}, " State ", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select State", -1)
const _hoisted_46 = ["value"]
const _hoisted_47 = { class: "col-md-4" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", {
  for: "city",
  class: "col-form-label text-md-right"
}, "City", -1)
const _hoisted_49 = { class: "col-md-4" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", {
  for: "zip_code",
  class: "col-form-label text-md-right"
}, "Zip Code", -1)
const _hoisted_51 = { class: "form-group row mb-4" }
const _hoisted_52 = { class: "col-md-12" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", {
  for: "comments",
  class: "col-form-label text-md-right"
}, " Comments (max 500 characters) ", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "form-group row col-md-12 mb-4 d-flex justify-content-end gap-2" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "reset",
    class: "btn btn-primary col-md-1"
  }, "Reset"),
  /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary col-md-1" }, "Submit")
], -1)
const _hoisted_55 = {
  key: 1,
  class: "d-flex flex-column align-items-center gap-4"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("h3", null, "To Continue Please...", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createTextVNode("Please "),
  /*#__PURE__*/_createElementVNode("a", { href: "profile.personal.edit" }, "update your personal information"),
  /*#__PURE__*/_createTextVNode(" to include your correct date of birth.")
], -1)
const _hoisted_58 = [
  _hoisted_56,
  _hoisted_57
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiselect = _resolveComponent("multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    ($setup.person && $setup.person.DateofBirth)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          method: "POST",
          onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submitCheckReplacement && $setup.submitCheckReplacement(...args)), ["prevent"]))
        }, [
          ($setup.success)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($setup.success), 1))
            : _createCommentVNode("", true),
          ($setup.errors.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.errors, (error, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(error), 1))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "participant_id",
                name: "PersonID",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.person.PersonID) = $event)),
                class: "form-control",
                readonly: ""
              }, null, 512), [
                [_vModelText, $setup.person.PersonID]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "first_name",
                name: "FirstName",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.person.FirstName) = $event)),
                class: "form-control",
                readonly: ""
              }, null, 512), [
                [_vModelText, $setup.person.FirstName]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "last_name",
                name: "LastName",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.person.LastName) = $event)),
                class: "form-control",
                readonly: ""
              }, null, 512), [
                [_vModelText, $setup.person.LastName]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "date_of_birth",
                name: "DateofBirth",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.person.DateofBirth) = $event)),
                class: "form-control",
                readonly: ""
              }, null, 512), [
                [_vModelText, $setup.person.DateofBirth]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                id: "check_type",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.requestType) = $event))
              }, _hoisted_20, 512), [
                [_vModelSelect, $setup.requestType]
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                id: "type",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.checkType) = $event))
              }, _hoisted_25, 512), [
                [_vModelSelect, $setup.checkType]
              ])
            ])
          ]),
          ($setup.checkType == 'check')
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createVNode(_component_multiselect, {
                    modelValue: $setup.selectedCheck,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.selectedCheck) = $event)),
                    options: $setup.checks,
                    multiple: false,
                    placeholder: "Select one",
                    label: "FormattedText",
                    "track-by": "check.Number",
                    name: "CheckCategory"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _withDirectives(_createElementVNode("input", {
                    id: "check_date",
                    type: "date",
                    class: "form-control datepicker",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.checkDate) = $event))
                  }, null, 512), [
                    [_vModelText, $setup.checkDate]
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _withDirectives(_createElementVNode("input", {
                    id: "check_number",
                    type: "text",
                    class: "form-control numberpicker",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.checkNumber) = $event))
                  }, null, 512), [
                    [_vModelText, $setup.checkNumber]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_33,
          ($setup.address)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "address",
                    name: "Street",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.address.Street1) = $event)),
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, $setup.address.Street1]
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "address2",
                    name: "Street2",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.address.Street2) = $event)),
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, $setup.address.Street2]
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    id: "country",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.address.Country) = $event))
                  }, [
                    _hoisted_41,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.countries, (country) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: country.ShortName,
                        key: country.ShortName
                      }, _toDisplayString(country.LongName), 9, _hoisted_42))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, $setup.address.Country]
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    id: "state",
                    name: "State",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.address.State) = $event))
                  }, [
                    _hoisted_45,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredStates, (state) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: state.ShortName,
                        key: state.ShortName
                      }, _toDisplayString(state.LongName), 9, _hoisted_46))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, $setup.address.State]
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "city",
                    name: "City",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.address.City) = $event)),
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, $setup.address.City]
                  ])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "zip_code",
                    name: "ZipCode",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.address.Zip) = $event)),
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, $setup.address.Zip]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _hoisted_53,
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                id: "comments",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.comments) = $event))
              }, " ", 512), [
                [_vModelText, _ctx.comments]
              ])
            ])
          ]),
          _hoisted_54
        ], 32))
      : (_openBlock(), _createElementBlock("div", _hoisted_55, _hoisted_58)),
    _createTextVNode(" " + _toDisplayString($setup.person), 1)
  ]))
}